import React, { useEffect, useState } from "react";
import {
  updateModuleData
} from "../../../../services/apiService";



function EditMstModule({ isOpen, onClose, rowData }) {
  const [formData, setFormData] = useState({
    id:"",
    moduleName: "",
    moduleDescription: "",
    url: "",
    syncURL: "",
  });

  useEffect(() => {
    if (rowData) {
      setFormData({
        id: rowData.id || "",
        moduleName: rowData.modulename || "",
        moduleDescription: rowData.moduledescription || "",
        url: rowData.url || "",
        syncURL: rowData.syncurl || "",
      });
    }
  }, [rowData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(formData);
    
    try {
      await updateModuleData(formData);
      alert("Module updated successfully!");
      window.location.reload(); 
      onClose();
    } catch (error) {
      alert("Failed to update module.");
    }
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
        <h2 className="text-2xl text-center font-semibold mb-4">Edit Module</h2>
        <form onSubmit={handleSubmit}> 
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label>Module Name</label>
              <input
                name="moduleName"
                value={formData.moduleName}
                onChange={handleChange}
                className="border p-2 rounded w-full"
              />
            </div>
            <div>
              <label>Module Description</label>
              <input
                name="moduleDescription"
                value={formData.moduleDescription}
                onChange={handleChange}
                className="border p-2 rounded w-full"
              />
            </div>
            <div>
              <label>URL</label>
              <input
                name="url"
                value={formData.url}
                onChange={handleChange}
                className="border p-2 rounded w-full"
              />
            </div>
            <div>
              <label>SYNC URL</label>
              <input
                name="syncURL"
                value={formData.syncURL}
                onChange={handleChange}
                className="border p-2 rounded w-full"
              />
            </div>
          </div>

          <div className="flex justify-between mt-4">
            <button
              onClick={onClose}
              className="bg-red-500 text-white px-4 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditMstModule;
